/**
 * The shader half of `human.cmp` — the color the game renders each palette
 * entry from, which is what a `.chara` extended float stores (squared).
 *
 * The game keeps every palette twice: the interface half is the creator's
 * swatch (`CharacterColorService`, what the tools show and match dyes
 * against) and the shader half is what reaches the model. Judging a float
 * needs the shader half: across the 2026-09-28 corpus every unedited float
 * equals it exactly — hair 982 of 982, skin 980 of 982, limbal 797 of 798 —
 * where the interface half never matches skin at all. Only the `.chara`
 * resolver and the palette provider built from it read this module, so nothing else
 * bundles the clan tables.
 *
 * Generated by `scripts/build-character-colors.ts` from the game file.
 */
// Both tables load on first use: the web app's core-runtime chunk has no room for them, and
// only a resolved .chara file ever needs them
let sharedShaderLoading = null;
let raceShaderLoading = null;
// A failed load is forgotten, so the next call tries again instead of rethrowing the
// cached rejection for the rest of the session (BUG-013, as in CharacterColorService)
function loadSharedShaderData() {
    sharedShaderLoading ??= import('../../data/character_colors/shader/shared.json', {
        with: { type: 'json' },
    })
        .then((module) => (module.default ?? module))
        .catch((err) => {
        sharedShaderLoading = null;
        throw err;
    });
    return sharedShaderLoading;
}
function loadRaceShaderData() {
    raceShaderLoading ??= import('../../data/character_colors/shader/race_specific.json', {
        with: { type: 'json' },
    })
        .then((module) => (module.default ?? module))
        .catch((err) => {
        raceShaderLoading = null;
        throw err;
    });
    return raceShaderLoading;
}
/**
 * The stored color for a palette entry, or null when the palette has no such
 * entry (or the clan table needs a tribe and gender the file does not name).
 */
export async function charaShaderHex(palette, index, subrace, gender) {
    if (palette === 'skin' || palette === 'hair') {
        if (!subrace || !gender)
            return null;
        const table = (await loadRaceShaderData())[palette];
        return table[subrace]?.[gender]?.[index] ?? null;
    }
    return (await loadSharedShaderData())[palette][index] ?? null;
}
//# sourceMappingURL=chara-shader-colors.js.map